/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Settings_Warmup_RoundingInputs */

const en_us2_workout_logging_settings_warmup_rounding = /** @type {(inputs: Workout_Logging_Settings_Warmup_RoundingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Round the warm-up to`)
};

const pt_br2_workout_logging_settings_warmup_rounding = /** @type {(inputs: Workout_Logging_Settings_Warmup_RoundingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arredondar o aquecimento para`)
};

const es_419_workout_logging_settings_warmup_rounding = /** @type {(inputs: Workout_Logging_Settings_Warmup_RoundingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redondear el calentamiento a`)
};

const pt_pt2_workout_logging_settings_warmup_rounding = /** @type {(inputs: Workout_Logging_Settings_Warmup_RoundingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arredondar o aquecimento para`)
};

const fr_fr2_workout_logging_settings_warmup_rounding = /** @type {(inputs: Workout_Logging_Settings_Warmup_RoundingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrondir l'échauffement à`)
};

const de_de2_workout_logging_settings_warmup_rounding = /** @type {(inputs: Workout_Logging_Settings_Warmup_RoundingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufwärmen runden auf`)
};

const it_it2_workout_logging_settings_warmup_rounding = /** @type {(inputs: Workout_Logging_Settings_Warmup_RoundingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrotonda il riscaldamento a`)
};

/**
* | output |
* | --- |
* | "Round the warm-up to" |
*
* @param {Workout_Logging_Settings_Warmup_RoundingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_settings_warmup_rounding = /** @type {((inputs?: Workout_Logging_Settings_Warmup_RoundingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Settings_Warmup_RoundingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_settings_warmup_rounding(inputs)
	if (locale === "es-419") return es_419_workout_logging_settings_warmup_rounding(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_settings_warmup_rounding(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_settings_warmup_rounding(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_settings_warmup_rounding(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_settings_warmup_rounding(inputs)
	return en_us2_workout_logging_settings_warmup_rounding(inputs)
});
export { workout_logging_settings_warmup_rounding as "workout-logging.settings_warmup_rounding" }